import loadImage from 'blueimp-load-image';

export const getImageInfoFromFile = async (fileImage, customOptions) => {
  const img = document.createElement('img');
  let url, blob;

  const options = {
    canvas: true,
    orientation: true,
    crossOrigin: 'anonymous',
    cache: 'no-cache',
    ...customOptions,
  };

  try {
    const { url: tmpUrl, blob: tmpBlob } = await new Promise((resolve, reject) => {
      loadImage(
        fileImage,
        (canvas) => {
          try {
            if (!HTMLCanvasElement.prototype.toBlob) {
              Object.defineProperty(HTMLCanvasElement.prototype, 'toBlob', {
                value: function (callback, type, quality) {
                  const dataURL = this.toDataURL(type, quality).split(',')[1];
                  setTimeout(function () {
                    const binStr = atob(dataURL),
                      len = binStr.length,
                      arr = new Uint8Array(len);

                    for (var i = 0; i < len; i++) {
                      arr[i] = binStr.charCodeAt(i);
                    }

                    callback(new Blob([arr], { type: type || 'image/png' }));
                  });
                },
              });
            }
            canvas.toBlob(
              (blob) => resolve({ url: URL.createObjectURL(blob), blob }),
              fileImage.type
            );
          } catch (error) {
            reject(error);
          }
        },
        options
      );
    });
    url = tmpUrl;
    blob = tmpBlob;
  } catch (e) {
    // eslint-disable-next-line
    console.error(e);
    return {};
  }
  const data = await new Promise((resolve) => {
    img.addEventListener('load', function () {
      resolve({
        width: this.naturalWidth,
        height: this.naturalHeight,
      });
    });
    img.setAttribute('src', url);
  });
  return {
    url,
    blob,
    ...data,
  };
};
